var helpers = require('./helpersFunction');

module.exports = function(app) {
	'use strict'
	app.directive('aiRecommendationsDir',aiRecommendationsDir);
	aiRecommendationsDir.$inject=['$rootScope','aiModalService','editorExludeShortcode','stripHtml','$timeout','$http','API_URL'];
	function aiRecommendationsDir($rootScope,aiModalService,editorExludeShortcode,stripHtml,$timeout,$http,API_URL) {
		return {
			restrict: 'E',
			scope:{
				funcionality: '=',
                multiple: '=',
                displayType: '=',   // "block" or "inline"
                displayTypeObj: '=', // "array of objects" or "array of strings"
                resultFromAi: '=',
                selectedSuggestion: '='
			},      
			replace:true,
			template: require('./partial/aiRecommendations.html'),
			link: function(scope, ele, $attrs, ctrl) {
                scope.recommendations = scope.resultFromAi;
                if(scope.funcionality == 'tags-suggestion') {
                    scope.selectedSuggestion.value = scope.recommendations.filter(function(tag){
                        return tag.exists;
                    });
                }
                scope.isActive = function(rec) {
                    if (scope.multiple) {
                        return (scope.selectedSuggestion.value || []).some(function(selected) {
                            return scope.displayTypeObj ? selected.name === rec.name : selected === rec;
                        });
                    } else {
                        return scope.displayTypeObj 
                            ? (scope.selectedSuggestion.value && scope.selectedSuggestion.value.name === rec.name)
                            : scope.selectedSuggestion.value === rec;
                    }
                };
                scope.toggleRecommendation = function(rec) {
                    if (scope.multiple) {
                        scope.selectedSuggestion.value = scope.selectedSuggestion.value || [];
                        var idx = scope.selectedSuggestion.value.findIndex(function(selected) {
                            return scope.displayTypeObj ? selected.name === rec.name : selected === rec;
                        });
                        if (idx === -1) {
                            scope.selectedSuggestion.value.push(rec);
                        } else {
                            scope.selectedSuggestion.value.splice(idx, 1);
                        }
                    } else {
                        scope.selectedSuggestion.value = rec;
                    }
                };
			}       
		}
	}
}



//////////////////
// WEBPACK FOOTER
// ./public/development/assets/app/js/directive/AIModal/aiRecomendationsDirective.js
// module id = 429
// module chunks = 0